
export function getStyle() {
  return {
    reportDatePicker: {
      '& .compared-date-range-picker': {
        display: 'block',
      },
    },
  };
}
